"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _constants = require("./constants");

var _default = new _immutable.Record({
  ab: null,
  abVariation: null,
  absoluteUrl: null,
  allowedSlugConflict: null,
  analyticsPageId: null,
  analyticsPageType: null,
  archived: null,
  areCommentsAllowed: null,
  attachedStylesheets: null,
  author: null,
  authorAt: null,
  authorEmail: null,
  authorName: null,
  authorUserId: null,
  authorUsername: null,
  blueprintTypeId: null,
  category: null,
  categoryId: null,
  commentCount: null,
  contentGroup: null,
  contentGroupId: null,
  created: null,
  createdTime: null,
  css: null,
  cssText: null,
  ctas: null,
  currentState: null,
  currentlyPublished: null,
  deletedAt: null,
  domain: null,
  enableGoogleAmpOutputOverride: null,
  featuredImage: null,
  featuredImageAltText: null,
  featuredImageHeight: null,
  featuredImageLength: null,
  featuredImageWidth: null,
  flexAreas: null,
  freezeDate: null,
  hasUserChanges: null,
  htmlTitle: null,
  id: null,
  isCaptchaRequired: null,
  isDraft: null,
  isInstantEmailEnabled: null,
  isPublished: null,
  isSocialPublishingEnabled: null,
  keywords: null,
  label: null,
  lastEditSessionId: null,
  lastEditUpdateId: null,
  listTemplate: null,
  liveDomain: null,
  meta: null,
  metaDescription: null,
  name: null,
  pageRedirected: null,
  pageTitle: null,
  parentBlog: null,
  personas: null,
  placementGuids: null,
  portalId: null,
  postBody: null,
  postBodyRss: null,
  postEmailContent: null,
  postEmailSummaryFeaturedImage: null,
  postFeaturedImageIfEnabled: null,
  postListContent: null,
  postListSummaryFeaturedImage: null,
  postRssContent: null,
  postRssSummaryFeaturedImage: null,
  postSummary: null,
  postSummaryRss: null,
  postTemplate: null,
  previewKey: null,
  processingStatus: null,
  publishDate: null,
  publishDateLocalTime: null,
  publishDateLocalized: null,
  publishImmediately: null,
  publishedUrl: null,
  resolvedDomain: null,
  rssSummaryFeaturedImage: null,
  slug: null,
  state: null,
  subcategory: null,
  syncedWithBlogRoot: null,
  templatePath: null,
  templatePathForRender: null,
  title: null,
  topicIds: null,
  topicList: null,
  topicNames: null,
  topics: null,
  translatedContent: null,
  tweetImmediately: null,
  unpublishedAt: null,
  updated: null,
  upsizeFeaturedImage: null,
  url: null,
  useFeaturedImage: null,
  widgetContainers: null,
  widgetcontainers: null,
  widgets: null
}, _constants.BLOG_POST);

exports.default = _default;
module.exports = exports.default;